import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const GetFaturasTomador = async(solicitacaoID) => {
    try {
        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/fatura/${solicitacaoID}`);

    } catch(error) {
        throw new Error(`Erro ao carregar as faturas do tomador`);
    }
}

export default {GetFaturasTomador}


// WEBPACK FOOTER //
// ./src/services/api/faturaTomador/index.js